<template>
  <div id="main-content" class="parent-notification-detail">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <template v-if="notificationDetail">
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.title') }}:</span>
            <span class="info-span"> {{ notificationDetail.title }} </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="content-row">
            <span class="form-lable">{{ $t('common.content') }}:</span>
            <span class="info-span" v-html="notificationContent"></span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span">
              <template v-if="notificationDetail.parent_info">{{ notificationDetail.parent_info.name }}</template>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="form-lable">{{ $t('common.time') }}:</span>
            <span class="info-span">{{ $moment(notificationDetail.created_at).format('YYYY-MM-DD h:mm:ss') }}</span>
          </el-col>
        </el-row>
      </template>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailParentNotification",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'notification.parent_notification',
        backLink: `/notification/parent?action=back`,
        notificationDetail: null
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.notificationDetail = Object.assign({}, response.data.data.notification_info)
      };
      let payload = {
        successCallback,
        id: this.$route.query.id
      }
      this.$store.dispatch('notification/retrieveParentNotificationDetail', payload)
    },
    computed: {
      notificationContent: function () {
        let content = ''
        content += `<div>${this.notificationDetail.header}</div>`

        if (Array.isArray(this.notificationDetail.reason_list)) {
          this.notificationDetail.reason_list.forEach((reasonItem) => {
            content += `
                <div class="reason-item clearfix">
                    <span><b>${reasonItem.title}</b>:</span>
                    <span>${reasonItem.data}</span>
                </div>
            `
          })
        }

        content += `<div>${this.notificationDetail.footer}</div>`

        return content
      }
    },
    methods: {

    }
  }
</script>

<style lang="scss">
  .parent-notification-detail {
    .form-lable {
      width: 10%;
    }

    .info-span {
      display: block;
      width: 90%;
      text-align: left;
    }

    .reason-item {
      > span {
        float: left;
        display: block;
        width: 10%;

        &:nth-child(2) {
          padding-left: 10px;
          width: 90%;
          box-sizing: border-box;
        }
      }
    }
  }
</style>
